<!--评论组件-->
<template>
    <section id="comment" v-if="isShow">
            <!--评论头部总评分等信息-->
            <div class="head">
                <div>
                    <ul class="star">
                        <!--综合评分-->
                        <li v-for="n in 5" v-bind:class='n|star(CommentData.startNum/20)' :key="n"></li>
                    </ul>
                    <span>{{CommentData.startNum}}分</span>
                    <a href="" @click.prevent="getDownURL(params)">共{{CommentData.total}}条评论</a>
                </div>
            </div>
            <ul class="messiges">
                <li  v-for="index in listsInfo.length" :key="index">
                    <div class="userinfo">
                        <img src="../../assets/img/food_businessmen_logo@2x.png" v-if="!CommentData.lists[index-1].userPicUrl" alt="">
                        <img :src="CommentData.lists[index-1].userPicUrl" v-else alt="">
                        <div>
                            <p>{{CommentData.lists[index-1].nickName}} <span>{{CommentData.lists[index-1].createTime | dateFormat('YYYY.MM.DD')}}</span></p>
                            <ul>
                                <li v-for="n in 5" v-bind:class='n|star(CommentData.lists[index-1].point/20)' :key="n"></li>
                            </ul>
                        </div>
                    </div>
                    <div class="info">
                        <!--评论内容-->
                        <p>{{listsInfo[index-1].text}}
                            <span v-if="listsInfo[index-1].flage">
                                  <a href="javascript:;" v-if="listsInfo[index-1].text&&listsInfo[index-1].text.length<=36" @click="getfullText(index-1)">查看全文</a>
                                  <a href="javascript:;" v-else @click="packUp(index-1)">收起</a>
                            </span>
                        </p>
                        <!--图片展示-->
                        <!--如果图片有4张的时候，有这个类名限制宽度-->
                        <div v-if="CommentData.lists[index-1].pics" :class="{four:CommentData.lists[index-1].pics.length == 4}">
                            <img :src="item.sPic.picUrl" alt="" v-for="(item,n) in CommentData.lists[index-1].pics" :key="n">
                        </div>
                    </div>
                </li>
            </ul>
    </section>
</template>

<script>
    import { fetchComment,fetchShopComment} from '../../common/api/homePage';
    import {getDownURL} from "../../common/api.config";
    export default {
        data(){
            return {
                listsInfo:[],
                isShow:false,
                CommentData:{}
            }
        },
        props: ['idobj', 'params'],
        watch:{
            idobj(curVal,oldVal){
                if(curVal){
                    switch (curVal.type){
                        case 'goodsId':
                            fetchComment(curVal.id).then(rep=>{
                                if(rep.data.code == 0){
                                    var data = rep.data.data;
                                    this.CommentData = {
                                        length:3,
                                        startNum:data.page.avgPoint,
                                        total:data.page.total,
                                        lists:data.goodsCommentPage
                                    };
                                    data.goodsCommentPage.map((val,index)=>{
                                        this.listsInfo[index] = this.disposeText(val.content);
                                    });
                                    if(this.listsInfo.length>0){
                                        this.isShow = true;
                                    }
                                }
                            });
                            break;
                        case 'shopId':
                            fetchShopComment(curVal.id).then(rep=>{
                                if(rep.data.code == 0){
                                    var data = rep.data.data;
                                    this.CommentData = {
                                        length:3,
                                        startNum:data.page.avgPoint,
                                        total:data.page.total,
                                        lists:data.goodsCommentPage
                                    };
                                    data.goodsCommentPage.map((val,index)=>{
                                        this.listsInfo[index] = this.disposeText(val.content);
                                    });
                                    if(this.listsInfo.length>0){
                                        this.isShow = true;
                                    }
                                }
                            });
                            break
                    }
                }
            }
        },
        created() {
            if(this.listsInfo.length>0){
                this.isShow = true;
            }
        },
        methods:{
            getDownURL,
            disposeText(val){
                var obj={};
                if(val.length>33){
                    obj.text= val.substr(0,33)+"...";
                    obj.flage = true;
                    return  obj;
                }else{
                    obj.text=val;
                    obj.flage = false;
                    return  obj;
                }
            },
            getfullText(index){
                              // 方法用于将所有可枚举的属性的值从一个或多个源对象复制到目标对象。它将返回目标对象。
                let listItem = Object.assign({}, this.listsInfo[index], {text: this.CommentData.lists[index].content});
                this.$set(this.listsInfo, index, listItem);
            },
            packUp(index){    // 这里传列表中的评论数据
                let listItem = Object.assign({}, this.listsInfo[index], {text:this.disposeText(this.CommentData.lists[index].content).text });
                this.$set(this.listsInfo, index, listItem);
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #comment{
        div.head{
            background-color: #fff;
            height:px2rem(44);
            padding:px2rem(14) px2rem(12);
            font-size: px2rem(12);
            color: #999;
            div{
                ul{
                    li{
                        float: left;
                        width:px2rem(14);
                        height: px2rem(14);
                        margin-right: px2rem(4);
                        background: url("../../assets/img/start.png") no-repeat 0 0;
                        background-size: cover;
                    }
                    li.full{
                        background-position:px2rem(-15) center ;
                    }
                    li.half{
                        background-position: px2rem(-29) center;
                        }
                    }
                span{
                    margin-left: px2rem(12);

                    line-height: px2rem(17);

                    letter-spacing: 0.14px;
                }
                a{
                    float: right;
                    color: #999;
                    padding-right: px2rem(20);
                    position: relative;
                    &:before{
                        content:'' ;
                        display: block;
                        position: absolute;
                        top:0;
                        right: 0;
                        width:px2rem(16);
                        height:px2rem(16);
                        background: url("../../assets/img/food_rigth_more.png") no-repeat center;
                        background-size: 100% 100%;
                    }
                }
                }
            }
        ul.messiges{
            li{
                overflow: hidden;
                padding:0 px2rem(12);
                background-color: #fff;
                div.userinfo{
                    height:px2rem(71);
                    border-top:1px solid #EEEEEE;
                    img{
                        box-sizing: content-box;
                        padding:px2rem(12);
                        padding-left: 0;
                        padding-bottom: px2rem(5);
                        width:px2rem(54);
                        height:px2rem(54);
                        border-radius: 50%;
                    }
                    div{
                        height:100%;
                        float: right;
                        width:px2rem(285);
                        padding-top: px2rem(21);
                        p{
                            font-size: px2rem(16);
                            color: #333333;
                            margin-bottom: px2rem(4);
                            span{
                                float: right;
                                text-align: right;
                                font-size: px2rem(12);
                                color: #999999;
                            }
                        }
                        ul{
                            li{
                                float: left;
                                width:px2rem(14);
                                height: px2rem(14);
                                margin-right: px2rem(4);
                                background: url("../../assets/img/start.png") no-repeat 0 0;
                                background-size: cover;
                                padding:0;
                            }
                            li.full{
                                background-position:px2rem(-15) center ;
                            }
                            li.half{
                                background-position: px2rem(-29) center;
                            }
                        }
                    }
                }
                div.info{
                    float: right;
                    width:px2rem(285);
                    padding-bottom: px2rem(24);
                    p{
                        font-size: px2rem(14);
                        line-height: px2rem(20);
                        margin-bottom: px2rem(12);
                        color:#666;
                        a{
                            color:#FF4A2A;
                        }
                    }
                    div{
                        overflow: hidden;
                        img{
                            float: left;
                            width:px2rem(80);
                            height:px2rem(80);
                            margin-right: px2rem(8);
                            margin-bottom: px2rem(8);
                        }
                    }
                    .four{
                        width:px2rem(180);
                    }

                }
            }
        }
        }
</style>